import { AuditDetails, Entity, SortableEntity } from '../entity';
import { ActivityEntityName, Lex, LexoRank } from '../shared';
import { EntityStatusType } from './enum';
import { v7 } from 'uuid';

export interface EntityStatus extends AuditDetails {
    _id: string;
    name: string;
    sortOrder?: Lex;
    system?: boolean;

    statusType: EntityStatusType;
    entityType: ActivityEntityName;
    subStatuses: EntitySubStatus[];

    active: boolean;
}

export interface EntitySubStatus extends AuditDetails, Entity {
    sortOrder?: Lex;

    parent?: SortableEntity;
    statusType?: EntityStatusType;
    systemName?: string;

    note?: string;

    /** Used to store the corresponding legacy status to facilitate migration to entityStatus */
    legacyStatus?: any

    isDefault?: boolean;
    isReadonly?: boolean;
}

export function buildEntityStatus(entity: ActivityEntityName, type: EntityStatusType, options?: Partial<EntityStatus>): EntityStatus {
    return {
        _id: v7(),
        sortOrder: LexoRank.first(),
        name: null,
        statusType: type,
        entityType: entity,
        subStatuses: [],
        active: true,
        ...(options || {}),
    }
}

export function buildEntityStatusSubStatus(status: EntityStatus, options?: Partial<EntitySubStatus>): EntitySubStatus {
    return {
        _id: v7(),
        sortOrder: LexoRank.first(),
        isDefault: false,
        isReadonly: false,
        legacyStatus: null,
        active: true,
        name: null,
        systemName: null,
        ...(options || {}),
        statusType: status.statusType,
    }
}